import { useQuery } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { useOutletContext } from "react-router-dom";
import { adminApi } from "../../api/admin";
import { errorMessage } from "../../shared/errors";
import { roleAtLeast, type StaffRole } from "../../shared/hooks/useStaff";
import { Alert, Badge, Button, Card, Input } from "../../ui";
import { Select } from "./shared";

export function StaffPage() {
  const { role } = useOutletContext<{ role: StaffRole }>();
  const isOwner = roleAtLeast(role, "owner");
  const staff = useQuery({
    queryKey: ["admin", "staff"],
    queryFn: adminApi.staff,
  });
  const [form, setForm] = useState({ email: "", role: "support" });
  const [message, setMessage] = useState<{
    kind: "success" | "error";
    text: string;
  } | null>(null);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    adminApi
      .grantStaff(form)
      .then((r) => {
        setMessage({ kind: "success", text: `${r.email} is now ${r.role}.` });
        setForm({ email: "", role: "support" });
        return staff.refetch();
      })
      .catch((err) => setMessage({ kind: "error", text: errorMessage(err) }));
  };
  return (
    <Card>
      <h1 className="mb-4 text-xl font-semibold">Staff</h1>
      <ul className="text-sm">
        {(staff.data ?? []).map((s) => (
          <li key={s.user_id} className="py-1">
            {s.email} <Badge>{s.role}</Badge>
          </li>
        ))}
      </ul>
      {message ? (
        <div className="mt-3">
          <Alert kind={message.kind}>{message.text}</Alert>
        </div>
      ) : null}
      <form
        onSubmit={submit}
        className="mt-4 flex flex-wrap items-end gap-2"
        aria-label="Grant staff role"
      >
        <Input
          label="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <Select
          label="Role"
          value={form.role}
          onChange={(r) => setForm({ ...form, role: r })}
          options={["support", "admin", "owner"].map((r) => ({
            value: r,
            label: r,
          }))}
        />
        <span title={isOwner ? undefined : "Owner role required"}>
          <Button type="submit" disabled={!isOwner || !form.email}>
            Grant
          </Button>
        </span>
      </form>
    </Card>
  );
}
